import "./AfterMovie.scss";
import TopInfo from "../../Components/TopInfo/TopInfo";

const AfterMovie = () => {
  const path = window.location.pathname;

  return (
    <>
      <div className="AfterMovie">
        <div className="pohondanawan"></div>
        <TopInfo />
        <div className="heading">
          <div className="judul">
            <p className="nama"><span>After Movie</span> OMB UMN 2023</p>
            {/* <p className="job">Akan segera hadir. Ditunggu, yah!</p> */}
          </div>
        </div>
        <div class="video-container">
          <iframe className="video" src="https://youtube.com/embed/XG3whlcTs9U?si=TJzU01-eZnrUCSdZ" frameborder="0" allowfullscreen></iframe>
        </div>
      </div>
    </>
  );
};

export { AfterMovie };